module.exports = __webpack_public_path__ + "img/orchid2.418f9f52.jpg";